<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 SWANトップページSECTION編集/新規作成
          p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページ内を構成するSECTIONコンテンツの編集画面
          form.form-horizontal
            .form-group
              label.col-md-12 お問い合わせ内容
              .col-md-12
                el-checkbox-group(v-model='formdata.check_detail')
                  el-checkbox(label='check1') 詳しい話を聞きたい
                  br
                  el-checkbox(label='check2') 塗料を含めた塗装システムを提案してほしい
                  br
                  el-checkbox(label='check3') 塗料テストをしたい
                  br
                  el-checkbox(label='check4') 塗装はしていない
                  br
                  el-checkbox(label='check5') ロボット塗装の実績がある
                  br
                  el-checkbox(label='check6') 塗装コストを下げたい
                  br
                  el-checkbox(label='check7') その他
              .col-md-12
                el-input(v-model='formdata.etc')
            .form-group
              label.col-md-12 詳細
              .col-md-12
                el-input(v-model='formdata.detail')
            .form-group
              label.col-md-12 社名
              .col-md-12
                el-input(v-model='formdata.company')
            .form-group
              label.col-md-12 社名(カナ)部署名
              .col-md-12
                el-input(v-model='formdata.company_kana')
            .form-group
              label.col-md-12 部署名
              .col-md-12
                el-input(v-model='formdata.position')
            .form-group
              label.col-md-12 部署名(カナ)
              .col-md-12
                el-input(v-model='formdata.position_kana')
            .form-group
              label.col-md-12 名前
              .col-md-12
                el-input(v-model='formdata.name')
            .form-group
              label.col-md-12 名前(カナ)
              .col-md-12
                el-input(v-model='formdata.name_kana')
            .form-group
              label.col-md-12 郵便番号 都道府県
              .col-md-12
                el-input(v-model='formdata.post_code')
            .form-group
              label.col-md-12 都道府県 市町村名
              .col-md-12
                el-input(v-model='formdata.county')
            .form-group
              label.col-md-12 市町村名
              .col-md-12
                el-input(v-model='formdata.city')
            .form-group
              label.col-md-12 番地 建物名など
              .col-md-12
                el-input(v-model='formdata.stree')
            .form-group
              label.col-md-12 建物名など 電話番号
              .col-md-12
                el-input(v-model='formdata.build')
            .form-group
              label.col-md-12 電話番号
              .col-md-12
                el-input(v-model='formdata.phone_number')
            .form-group
              label.col-md-12 FAX番号
              .col-md-12
                el-input(v-model='formdata.fax_number')
            .form-group
              label.col-md-12 E-mail
              .col-md-12
                el-input(v-model='formdata.email')
            //- .form-group
            //-   label.col-md-12 E-mail(確認)
            //-   .col-md-12
            //-     el-input(v-model='formdata.check_email')
            

</template>

<script>
export default {
  name: 'Top',
  data () {
    return {
      formdata: {
        check_detail: [],
        etc: '',
        detail: '',
        company: '',
        company_kana: '',
        position: '',
        position_kana: '',
        name: '',
        name_kana: '',
        post_code: '',
        county: '',
        city: '',
        stree: '',
        build: '',
        phone_number: '',
        fax_number: '',
        email: '',
        check_email: ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/contact/edit.vue